import LoseBase from '../components/base/lose-base';
import { UDFormLabeledCheckbox, UDFormLabeledInput } from 'ud-form/components';

const FootballLose = () => {
  return (
    <LoseBase sportType="football">
      <div className="mt-4">
        <UDFormLabeledInput
          name="settings.lossPenaltySeries"
          placeholder="0 очков"
          label="В серии послематчевых пенальти"
          tooltip="Очки за проигрыш по пенальти (например, 1 очко за 'боевую ничью')."
          tooltipProps={{ position: 'input-right' }}
        />

        <UDFormLabeledCheckbox
          name="settings.technicalDefeatGoalsCount"
          label="Учёт голов при техническом поражении"
          containerClassName="flex items-center"
          tooltip="Засчитывать ли голы в статистику, если матч завершён техническим поражением (например, из-за неявки)."
          tooltipProps={{ position: 'input-right' }}
        />
      </div>
    </LoseBase>
  );
};

export default FootballLose;
